import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth } from './view-utilities.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  h2ld0l0a2c9zpb as h2,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { dialog3sxbjr735jrum as dialog } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  Companion_getInstance3htwskyquhuuo as Companion_getInstance,
  Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { set_padding5v7ifiir6y9y as set_padding } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/Element.ext.mjs';
import { get_atEnd34105oxxaxc2o as get_atEnd } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { beforeSetupw9y6lebwkk6y as beforeSetup } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementWriter.ext.mjs';
import { SidePanelSemantic_getInstance2ldeh6wpizc8 as SidePanelSemantic_getInstance } from '../../theme/semantics.mjs';
import { overlayt2e94k47ee8y as overlay } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewContextExtensions.commonHtml.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { animateInmud32j2tnt7g as animateIn } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/animations.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function confirmationDialog(_this__u8e3s4, header, body, confirmationText, confirmationTheme, cancelText, onCancel, onConfirm) {
  body = body === VOID ? null : body;
  confirmationTheme = confirmationTheme === VOID ? ImportantSemantic_getInstance() : confirmationTheme;
  cancelText = cancelText === VOID ? 'Cancel' : cancelText;
  var tmp;
  if (onCancel === VOID) {
    tmp = confirmationDialog$slambda();
  } else {
    tmp = onCancel;
  }
  onCancel = tmp;
  return dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    h2(element, header);
    var tmp0_safe_receiver = body;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(element);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(element_1, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    this_1.willAddChild_hz2iwc_k$(element_2);
    text(element_2, cancelText);
    onClick(element_2, VOID, VOID, VOID, confirmationDialog$lambda$slambda(onCancel, close));
    element_2.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_2);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_2 = weight(element_1, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Space())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_2.willAddChild_hz2iwc_k$(element_3);
    element_3.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_3 = themed(element_1, confirmationTheme.plus_duvq05_k$(ButtonSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (Button())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    this_3.willAddChild_hz2iwc_k$(element_4);
    text(element_4, confirmationText);
    onClick(element_4, VOID, VOID, VOID, confirmationDialog$lambda$slambda_0(onConfirm, close));
    element_4.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_4);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function sidePanel(_this__u8e3s4, width, content) {
  width = width === VOID ? get_rem(22) : width;
  var tmp = Companion_getInstance().Fade_1;
  overlay(_this__u8e3s4, VOID, VOID, tmp, ($this$overlay, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (DismissBackground())($this$overlay.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$overlay.willAddChild_hz2iwc_k$(element);
    set_padding(element, get_px(0));
    element.onClick_tk88x3_k$(sidePanel$lambda$slambda(close));
    var tmp = get_atEnd(element);
    // Inline function 'com.lightningkite.kiteui.views.card' call
    var this_0 = themed(sizeConstraints(beforeSetup(tmp, sidePanel$lambda$lambda), VOID, VOID, VOID, VOID, VOID, width), SidePanelSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
    var this_1 = themed(this_0, CardSemantic_getInstance());
    var tmp$ret$4 = themed(this_1, ForcePaddingSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_2 = get_scrolling(tmp$ret$4);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_2.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(true);
    content(element_0, close);
    element_0.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_0);
    element.onStartup_vrxh3i_k$();
    $this$overlay.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
}
function confirmationDialog$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return Unit_instance;
  }), 0);
}
function confirmationDialog$lambda$slambda($onCancel, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $($onCancel($completion), $completion);
    $close();
    return Unit_instance;
  }), 0);
}
function confirmationDialog$lambda$slambda_0($onConfirm, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $($onConfirm($completion), $completion);
    $close();
    return Unit_instance;
  }), 0);
}
function sidePanel$lambda$slambda($close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $close();
    return Unit_instance;
  }), 0);
}
function sidePanel$lambda$lambda($this$beforeSetup) {
  animateIn($this$beforeSetup, Companion_getInstance_0().FromRight_1);
  return Unit_instance;
}
//region block: exports
export {
  confirmationDialog as confirmationDialoginprr3lfvaqc,
  sidePanel as sidePanel1n7xwnpayabwm,
};
//endregion

//# sourceMappingURL=dialogs.mjs.map
